import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageLayout } from '@hero/layouts';
import { useGetUser } from '@hero/services/organization-service/hooks';
import { HomeTemplate } from '@hero/templates';

export default function Page({ pageData }) {
  const { t } = useTranslation();
  const { data: userData } = useGetUser();

  return (
    <PageLayout
      header={{
        title: t('hiUser', { firstName: userData?.firstName })
      }}
      pageData={pageData}
    >
      <HomeTemplate />
    </PageLayout>
  );
}
